import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';

// Must be the SAME Clerk instance the iOS app uses (pk_live_... in production),
// because Supabase third-party auth trusts exactly one Clerk domain — admin
// sign-ins on a different instance would fail RLS. Set in .env / Vercel env.
const publishableKey =
  process.env.REACT_APP_CLERK_PUBLISHABLE_KEY ||
  'pk_test_aW1tZW5zZS1tdXN0YW5nLTM5LmNsZXJrLmFjY291bnRzLmRldiQ';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ClerkProvider publishableKey={publishableKey}>
    <App />
  </ClerkProvider>
);